import { useState, useEffect } from 'react'
import { apiFetch } from '../services/api'

export default function AlertasVencimiento() {
  const [alertas, setAlertas] = useState([])
  const [loading, setLoading] = useState(true)
  const [expandido, setExpandido] = useState(false)

  useEffect(() => {
    cargarAlertas()
    const intervalo = setInterval(cargarAlertas, 300000) // Cada 5 min
    return () => clearInterval(intervalo)
  }, [])

  const cargarAlertas = async () => {
    try {
      const data = await apiFetch('/inventario/alertas_vencimiento')
      setAlertas(data.alertas || [])
    } catch (e) {
      console.warn('Error cargando alertas:', e)
    } finally {
      setLoading(false)
    }
  }

  if (loading || alertas.length === 0) return null

  const criticas = alertas.filter(a => a.urgencia === 'CRÍTICA')
  const normales = alertas.filter(a => a.urgencia !== 'CRÍTICA')

  return (
    <div style={{
      background: criticas.length > 0 ? '#fef2f2' : '#fef9e7',
      border: `2px solid ${criticas.length > 0 ? '#fca5a5' : '#fcd34d'}`,
      borderRadius: '8px',
      padding: '1rem',
      marginBottom: '1.5rem'
    }}>
      <div
        onClick={() => setExpandido(!expandido)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
          cursor: 'pointer',
          fontWeight: '600',
          color: criticas.length > 0 ? '#991b1b' : '#92400e',
          fontSize: '0.95rem'
        }}
      >
        <span style={{ fontSize: '1.25rem' }}>
          {criticas.length > 0 ? '🚨' : '⚠️'}
        </span>
        <span>
          {criticas.length > 0 ? `${criticas.length} producto(s) VENCIDO(S)/CRÍTICO(S)` : `${alertas.length} producto(s) con alerta de vencimiento`}
        </span>
        <span style={{ marginLeft: 'auto', fontSize: '0.875rem', opacity: 0.7 }}>
          {expandido ? '▼' : '▶'}
        </span>
      </div>

      {expandido && (
        <div style={{ marginTop: '1rem', borderTop: `1px solid ${criticas.length > 0 ? '#fecaca' : '#fde047'}`, paddingTop: '1rem' }}>
          {criticas.length > 0 && (
            <div style={{ marginBottom: '1rem' }}>
              <h4 style={{ fontSize: '0.875rem', fontWeight: '600', color: '#991b1b', margin: '0 0 0.5rem 0' }}>
                🔴 CRÍTICA (Vence en &lt; 7 días)
              </h4>
              {criticas.map(a => (
                <div key={a.lote_id} style={{
                  background: '#fff',
                  padding: '0.75rem',
                  borderRadius: '4px',
                  marginBottom: '0.5rem',
                  borderLeft: '4px solid #dc2626',
                  fontSize: '0.875rem'
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
                    <strong>{a.producto_nombre}</strong>
                    <span style={{ color: '#dc2626', fontWeight: '600' }}>
                      {a.dias_para_vencer} días
                    </span>
                  </div>
                  <div style={{ color: '#64748b', fontSize: '0.8rem' }}>
                    Lote: {a.numero_lote} | Stock: {a.stock} | Vence: {a.fecha_vencimiento}
                  </div>
                </div>
              ))}
            </div>
          )}

          {normales.length > 0 && (
            <div>
              <h4 style={{ fontSize: '0.875rem', fontWeight: '600', color: '#92400e', margin: '0 0 0.5rem 0' }}>
                🟡 ALERTA (Vence en 7-30 días)
              </h4>
              {normales.map(a => (
                <div key={a.lote_id} style={{
                  background: '#fff',
                  padding: '0.75rem',
                  borderRadius: '4px',
                  marginBottom: '0.5rem',
                  borderLeft: '4px solid #f59e0b',
                  fontSize: '0.875rem'
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
                    <strong>{a.producto_nombre}</strong>
                    <span style={{ color: '#f59e0b', fontWeight: '600' }}>
                      {a.dias_para_vencer} días
                    </span>
                  </div>
                  <div style={{ color: '#64748b', fontSize: '0.8rem' }}>
                    Lote: {a.numero_lote} | Stock: {a.stock} | Vence: {a.fecha_vencimiento}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
